<template>
  <div>
    <Loading ref="loading" />
    <Toast ref="toast" />
    <div class="page-container">
      <header class="content-hero-container">
        <div class="text-hero-container">
          <h1 class="hero-text">
            Post your job everywhere
            <span style="color: var(--primary-color);">in 2 minutes</span>
          </h1>
          <h2 class="secondary-text">
            You write the job offer and our system will send it to a large selection of niche-specific job boards. No need to spend hours
            searching for them!
          </h2>

          <div class="cta-container" id="subscription">
            <div class="box-shadow">
              <input
                class="input-container input-conatiner-medium"
                placeholder="Enter your email"
                ref="email1"
                id="email1"
                name="email1"
                v-model="email1"
                @click="select($refs.email1, email1)"
                type="text"
                @keyup.enter="goPost(email1)"
                maxlength="1000"
              />
              <button class="primary-button" type="button" @click="subscribe(email1)">
                Post your job now
              </button>
            </div>
          </div>

          <div>
            <p v-if="alreadyUsed" class="p-error">
              ⚠️ Email already registered.
            </p>
            <p v-if="serverError" class="p-error">
              ⚠️ Server error, something went really bad. Try again or contanct my developers, they forgot some code.
            </p>
            <p v-if="showEmailBadFormat" class="p-error">
              ⚠️ Email not looking correct, try with the following format: name@domain.com
            </p>
          </div>
        </div>
      </header>

      <div class="split"></div>

      <div class="center-items">
        <div class="image-screenshot-container">
          <img
            class="image-hero"
            style="box-shadow: 0px 20px 50px rgba(223, 223, 223, 1); border-radius: 0.6rem;"
            src="@/assets/jobboardy-hero-image.png"
          />
        </div>
      </div>

      <div class="split"></div>

      <div class="center-items">
        <div class="image-sites-container">
          <img class="image-hero" src="@/assets/jobboardy-hero-web.png" />
        </div>
      </div>

      <div class="content-hero-container" style="padding-bottom: 5rem; padding-top: 2rem;">
        <div class="text-hero-container">
          <h1 class="hero-text">The easiest way to send job offers</h1>
        </div>
      </div>
      <div class="landing-info-container">
        <!-- Step 1 -->
        <div class="landing-step-container">
          <div class="landing-step-text">
            <h2 class="subtitle-text">STEP 1</h2>

            <div class="feature-home">
              <div class="icon-container">
                <i class="fas fa-search icon"></i>
              </div>
              <h1 class="title-text" style="margin-top: 0rem; margin-bottom: 0rem;">
                Select sites
              </h1>
            </div>

            <h2 class="secondary-text">
              We have a selection of the best job board sites and communities to reach top-notch candidates for your niche.
            </h2>
          </div>
          <div class="image-step1-container">
            <img
              class="image-hero"
              style="box-shadow: 0px 20px 50px rgba(223, 223, 223, 1); border-radius: 0.6rem;"
              src="@/assets/jobboardy-select-site.png"
            />
          </div>
        </div>

        <!-- Step 2 -->
        <div class="landing-step-container-reverse">
          <div class="image-step2-container">
            <img
              class="image-hero"
              style="box-shadow: 0px 20px 50px rgba(223, 223, 223, 1); border-radius: 0.6rem;"
              src="@/assets/jobboardy-job-offer.png"
            />
          </div>
          <div class="landing-step-text">
            <h2 class="subtitle-text">STEP 2</h2>

            <div class="feature-home">
              <div class="icon-container">
                <i class="far fa-file-alt icon"></i>
              </div>
              <h1 class="title-text" style="margin-top: 0rem; margin-bottom: 0rem;">
                Write your job offer
              </h1>
            </div>
            <h2 class="secondary-text">
              You only have to fill out our curated job description template to attract talent or write your own job offer.
            </h2>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="landing-step-container">
          <div class="landing-step-text">
            <h2 class="subtitle-text">STEP 3</h2>

            <div class="feature-home">
              <div class="icon-container">
                <i class="fas fa-rocket icon"></i>
              </div>
              <h1 class="title-text" style="margin-top: 0rem; margin-bottom: 0rem;">
                Send
              </h1>
            </div>
            <h2 class="secondary-text">
              Our system will send your job offer to a large selection of niche-specific job boards.
            </h2>
          </div>
          <div class="image-step3-container">
            <img
              class="image-hero"
              style="box-shadow: 0px 20px 50px rgba(223, 223, 223, 1); border-radius: 0.6rem;"
              src="@/assets/jobboardy-job-sent.png"
            />
          </div>
        </div>
      </div>

      <div class="content-hero-container" style="padding-bottom: 5rem; padding-top: 2rem;">
        <div class="text-hero-container">
          <h1 class="hero-text">
            Job Boardy sends your job offers, we know you are busy
          </h1>
        </div>
      </div>

      <!-- Founders note -->
      <div class="features-container" style="margin-bottom: 10rem; margin-top: 0rem;">
        <div class="box" style="padding: 3rem;">
          <p class="secondary-text">
            <b
              >Most recruiters spent +10 hours per week posting job offers here and there, but the main focus for them should be to attract
              great talents.</b
            >
          </p>

          <p class="secondary-text">
            Yes, that’s an insane amount of time that could be invested in the hiring process.
          </p>

          <p class="secondary-text">
            <b>That’s why we build Job Boardy</b> - to let you focus on finding talented candidates to work for your business instead of
            posting job offers.
          </p>

          <p class="secondary-text">
            We want to save you time, so our tool will send your job offers to most relevant sites within a single submission.
          </p>

          <p class="secondary-text">
            If you value your time, I’d love for you to give Job Boardy a try.
          </p>

          <div class="center-items" style="justify-content: flex-start; margin-bottom: 0rem;">
            <div class="image-founder-container">
              <img class="image-hero" src="@/assets/profile-teodora.png" />
            </div>
            <div>
              <p style="margin-bottom:0rem; margin-top:0rem;">
                <b>Teodora</b>
              </p>
              <p style="margin-bottom:0rem; margin-top:0rem;">
                Co-founder of Job Boardy
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <NewsletterCTA />

    <CulDeSac />
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import CulDeSac from "@/components/CulDeSac";
import NewsletterCTA from "@/components/NewsletterCTA";
import Toast from "@/components/Toast";
import firebase from "@/firebase";
import * as validator from "email-validator";

export default {
  components: {
    Loading,
    CulDeSac,
    NewsletterCTA,
    Toast,
  },

  created() {
    window.scrollTo(0, 0);
  },

  data() {
    return {
      email1: "",
      email2: "",
      showEmailBadFormat: false,
      serverError: false,
      alreadyUsed: false,
    };
  },

  methods: {
    select(ref, model) {
      ref.focus();
      ref.setSelectionRange(0, model.length);
    },

    async subscribe(email) {
      this.$refs.loading.open();

      this.serverError = false;
      this.showEmailBadFormat = false;
      this.alreadyUsed = false;

      if (!validator.validate(email)) {
        this.showEmailBadFormat = true;
        this.email1 = "";
        this.email2 = "";
        this.$refs.loading.close();
        return;
      }

      try {
        const jobboardyList = "814bc043-3bfc-11eb-a3d0-06b4694bee2a";
        await firebase.functions.httpsCallable("addSubscriber")({
          email,
          list: jobboardyList,
        });
        this.email1 = "";
        this.email2 = "";

        this.$refs.toast.text = "We will send you an email when we are ready to launch.";
        await this.$refs.toast.show();
        this.$router.push({ path: "/post-job" });
        this.$refs.loading.close();
      } catch (error) {
        if (error.code === "aborted") {
          this.alreadyUsed = true;
          this.email1 = "";
          this.email2 = "";
          this.$refs.loading.close();
          return;
        }
        this.email1 = "";
        this.email2 = "";
        this.serverError = true;
        console.error(error);
        this.$refs.loading.close();
      }
    },
  },
};
</script>

<style></style>
